export const mockDashboardData = {
	lastUpdated: "2026-05-12 14:30",

	selectedRange: {
		startDate: "2026-05-01",
		endDate: "2026-05-12",
	},

	localTransactional: {
		data: [],
		pendingTotal: 0,
	},

	localOtp: {
		data: [],
		pendingTotal: 0,
	},

	localBulk: {
		data: [],
		pendingTotal: 0,
	},

	internationalTransactional: {},

	internationalOtp: {},

	internationalBulk: {},
};